import React from "react";
import { Alert, Spinner, Table } from "reactstrap";
import {
  ensureArray,
  fmtHoverDateTime,
  fmtRelativeTime,
  formatBuyerFirstUserLine,
} from "./storeSalesDashboardHelpers";

const StoreSalesDashboardDealersSection = ({
  dealersLoading,
  dealersError,
  dealerRows,
  openNotificationsForName,
}) => {
  if (dealersLoading) {
    return (
      <div className="py-4 text-center text-muted">
        <Spinner className="me-2" />
        Loading…
      </div>
    );
  }
  if (dealersError) {
    return (
      <Alert color="danger" className="mb-0" fade={false}>
        {dealersError}
      </Alert>
    );
  }

  return (
    <Table
      bordered
      hover
      responsive
      className="mb-0 store-sales-table"
    >
      <thead className="store-sales-table__head">
        <tr>
          <th>Name</th>
          <th>Signed up</th>
          <th>Buyers</th>
          <th>Invites</th>
        </tr>
      </thead>
      <tbody>
        {dealerRows.length === 0 ? (
          <tr>
            <td colSpan={4} className="text-muted text-center py-4">
              No dealers found.
            </td>
          </tr>
        ) : (
          dealerRows.map((row) => (
            <tr key={row.id}>
              <td>
                <div className="d-flex align-items-center gap-2">
                  <span>
                    {row.name}{" "}
                    <span className="text-muted">#{row.id}</span>
                  </span>
                  <button
                    type="button"
                    className="store-whatsapp-button"
                    title="View notifications"
                    onClick={() => openNotificationsForName(row.name)}
                  >
                    <i className="fa-brands fa-whatsapp" aria-hidden="true" />
                  </button>
                </div>
                <div className="small text-muted">{row.mobile}</div>
              </td>
              <td title={fmtHoverDateTime(row.signedUpAt)}>
                {fmtRelativeTime(row.signedUpAt)}
              </td>
              <td>
                {row.buyers.length === 0 ? (
                  <span className="text-muted">-</span>
                ) : (
                  row.buyers.map((buyer) => {
                    const user = ensureArray(buyer?.buyer_users)[0];
                    const buyerName =
                      String(buyer?.name || "").trim() || "—";
                    const notifyName = buyerName !== "—" ? buyerName : "";
                    return (
                      <div
                        key={buyer?.id || `${buyerName}-${user?.mobile || ""}`}
                        className="mb-1"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <span>{buyerName}</span>
                          {notifyName ? (
                            <button
                              type="button"
                              className="store-whatsapp-button"
                              title="View notifications"
                              onClick={() =>
                                openNotificationsForName(notifyName)
                              }
                            >
                              <i
                                className="fa-brands fa-whatsapp"
                                aria-hidden="true"
                              />
                            </button>
                          ) : null}
                        </div>
                        <div className="small text-muted">
                          {formatBuyerFirstUserLine(user)}
                        </div>
                      </div>
                    );
                  })
                )}
              </td>
              <td>
                {row.invites.length === 0 ? (
                  <span className="text-muted">-</span>
                ) : (
                  row.invites.map((invite) => {
                    const inviteName =
                      String(invite?.name || "").trim() || "Unknown";
                    const inviteMobile = String(invite?.mobile || "").trim();
                    const sentTimeAgo = String(
                      invite?.sent_time_ago || ""
                    ).trim();
                    return (
                      <div
                        key={
                          invite?.id || `${inviteName}-${inviteMobile}`
                        }
                      >
                        <span>{inviteName}</span>
                        <button
                          type="button"
                          className="store-whatsapp-button ms-2"
                          title="View notifications"
                          onClick={() =>
                            openNotificationsForName(inviteName)
                          }
                        >
                          <i
                            className="fa-brands fa-whatsapp"
                            aria-hidden="true"
                          />
                        </button>
                        {inviteMobile ? ` (${inviteMobile})` : ""}
                        <span className="text-muted small">
                          {sentTimeAgo ? ` - ${sentTimeAgo} ago` : ""}
                        </span>
                      </div>
                    );
                  })
                )}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default StoreSalesDashboardDealersSection;
